module.exports = __webpack_public_path__ + "img/add-01.0e31ec6d.svg";